import React, { useState } from 'react';
import {
  TextField,
  Autocomplete,
  createFilterOptions,
} from '@mui/material';

const filter = createFilterOptions();

const AutocompleteWithAdd = ({
  label,
  options,
  onAdd,
  onChange,
  value,
  canAdd = true,
  ...props
}) => {
  const [inputValue, setInputValue] = useState('');

  return (
    <Autocomplete
      {...props}
      value={value}
      onChange={(event, newValue) => {
        if (typeof newValue === 'string') {
          // Option typed manually
          onChange(newValue);
        } else if (newValue && newValue.label.includes("+ Agregar ")) { 
          // User selected "+ Add" option
          setInputValue('');
          onChange('');
          onAdd(newValue.inputValue);
          
        } else {
          onChange(newValue);
        }
      }}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);
        const { inputValue } = params;

        const isExisting = options.some((option) => inputValue === option);
        //if (inputValue !== '' && !isExisting) {
        if(canAdd) {
          filtered.push({
            inputValue,
            label: `+ Agregar ${label}`,
          });
        }

        return filtered;
      }}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      getOptionLabel={(option) => {
        if (typeof option === 'string') return option;
        if (option.inputValue) return option.inputValue;
        return option.label || '';
      }}
      renderOption={(props, option) => (
        <li {...props}>
          {option.label || option}
        </li>
      )}
      freeSolo
      options={options}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      renderInput={(params) => (
        <TextField {...params} placeholder={label} variant="outlined"  sx={{color:label.includes("+ Agregar ")&& "primary.main"}}/>
      )}
    />
  );
};

export default AutocompleteWithAdd;
